export default "__VITE_ASSET__DpS19488__"